import React, { Component } from "react"
import Nav from "./Nav"
import Menu from "./Menu"
import "../static/css/index.css"
import InnovationCenter from "../containers/InnovationCenter/InnovationCenter";
import Register from "../containers/Register/Register";
import Home from "../containers/Home/Home";
import AboutUs from "../containers/AboutUs/AboutUs";
import Activities from "../containers/Activities/Activities";
import PublicActivities from "../containers/PublicActivities";
import TeamAct from "../containers/Activities/teamAct";
import Activities1 from "../containers/Activities/Activities1";
import Activities2 from "../containers/Activities/Activities2";
import Activities3 from "../containers/Activities/Activities3";
import Activities5 from "../containers/Activities/Activities5";
import NearTermActivities from "../containers/Home/NearTermActivities";
import NearTerm from "../containers/News/NearTerm";
import Login from "../containers/Login/Login";
import News from "../containers/News/News";
import ShCenter from "../containers/ShCenter/ShCenter"
import SzCenter from "../containers/SzCenter/SzCenter"
import ShAboutUs from "../containers/ShAboutUs/ShAboutUs"
import SzAboutUs from "../containers/SzAboutUs/SzAboutUs"
import TjCenter from "../containers/TjCenter/TjCenter";
import TjAboutUs from "../containers/TjAboutUs/TjAboutUs";
import TjltzngcCenter from "../containers/TjltzngcCenter/TjltzngcCenter";
import { Switch, Route, Redirect } from "react-router-dom"


import { IntlProvider, addLocaleData, FormattedMessage } from 'react-intl';

import zhCN from '../langConfig/zh-CN.js';  //导入 i18n 配置文件,需要手动创建并填入语言转换信息
import enUS from '../langConfig/en-US.js';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import { Modal, Button } from 'antd';
import { connect } from "react-redux"
import actions from "../store/actions"

import { withRouter } from 'react-router-dom';
import ScrollToTop from './ScrollToTop.js';
import ActivityDetail from '../containers/Activities/ActivityDetail'
import Successful from '../containers/Successful'
import Track from '../Track'
/* import AuthRoute from './AuthRoute' */
addLocaleData([...en, ...zh]);


/*let router = [
    {
        path: "/Home",
        component: Home
    },
    {
        path: "/Register",
        component: Register
    },
]*/


class App extends Component {
    state = { showModalTip: false }
    clickGroup() {
        this.setState({

            showModalTip: true
        })
    }
    hideTip() {
        this.setState({

            showModalTip: false
        })
    }
    goToActivity() {
        //window.open('https://mp.weixin.qq.com/s/8hnpMbLUd1x8thAXHdqiCw')
        this.setState({

            showModalTip: false
        }, () => { this.props.history.push({ pathname: "/Event" }); })

    }
    goToGroup() {
        this.setState({

            showModalTip: false
        }, () => {
            this.props.history.push({ pathname: "/Group", name: this.currentDay });
        })
    }

    chooseLocale = () => {
        console.log(this.props.local)
        switch (this.props.local) {
            // switch(window.localStorage.getItem("local_lang")){
            case 'en':
                return enUS;
            case 'zh':
                return zhCN;
            default:

                return enUS;
        }
    };

    componentWillMount = () => {
        //  var lang=  window.localStorage.getItem("local_lang");
        //  if(lang==='zh'){

        //  }else{
        //this.props.local="en";

        //  }
        console.log('app=>',this.props);
    }
    componentWillReceiveProps(nextProps) {

        if (nextProps.location.pathname !== this.props.location.pathname) {
            // console.log(this.props.location);
            Track({
                Type1: "url",
                Type2: "route",
                Event: "page",
                Source: "pc",//wp miniprogram pc
                FromUrl: this.props.location.pathname,
                Url: nextProps.location.pathname
            });
        }
    }
    componentDidMount() {
        //console.log("hash change3");
        Track({
            Type1: "url",//url event
            Type2: "route",
            Event: "page",
            Source: "pc",
            FromUrl: ""
        });
    }

    render() {
        return <IntlProvider locale={this.props.local} messages={this.chooseLocale()}>
            <div>
                <Modal
                    title={this.props.local === 'zh' ? "欢迎" : "Welcome"}
                    visible={this.state.showModalTip}
                    //onOk={this.goToGroup.bind(this)}
                    onCancel={this.hideTip.bind(this)}

                    footer={<div><Button type="primary" className="btn-color-vi2" onClick={this.goToGroup.bind(this)}><FormattedMessage id="intl-GroupReservation" /></Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button onClick={this.goToActivity.bind(this)}><FormattedMessage id="intl-EventSignUp" /></Button></div>}
                >
                    <p><FormattedMessage id="intl-ActivityTip" /></p>


                </Modal>
                <div className="Header">
                    <Nav clickGroup={this.clickGroup.bind(this)} />
                </div>

                <div className="Content">
                    <ScrollToTop>
                        <Switch>
                            <Route path='/Home' exact component={Home} />
                            <Route path='/Center' exact component={InnovationCenter} />
                            <Route path='/Event' exact component={PublicActivities} />
                            <Route path='/Group' exact component={TeamAct} />
                            <Route path='/Activities2' exact component={Activities2} />
                            <Route path='/Activities3' exact component={Activities3} />
                            <Route path='/Activities5' exact component={Activities5} />
                            <Route path='/NearTermActivities' exact component={NearTermActivities} />
                            <Route path='/NearTerm' exact component={NearTerm} />
                            <Route path='/News' exact component={News} />
                            <Route path='/AboutUs' exact component={AboutUs} />
                            <Route path='/Login' exact component={Login} />
                            <Route path='/Register' exact component={Register} />
                            <Route path='/ActivityDetail/:id' exact component={ActivityDetail} />
                            <Route path='/Successful' exact component={Successful} />
                            <Route path='/shcenter' exact component={ShCenter} />
                            <Route path='/szcenter' exact component={SzCenter} />
                            <Route path='/shaboutus' exact component={ShAboutUs} />
                            <Route path='/SzAboutUs' exact component={SzAboutUs} />
                            <Route path='/tjcenter' exact component={TjCenter} />
                            <Route path='/tjaboutus' exact component={TjAboutUs} />
                            <Route path='/tjltzngccenter' exact component={TjltzngcCenter} />
                            <Redirect to='/Home' />
                            {/*      {router.map((item, index) => {
                            //权限验证  根据当前权限  只能渲染首页
                            if (item.path !== "/Home") return
                            //如果权限不够  转到404
                            return<div>
                                <Route key={index} path={item.path} component={item.component}/>
                            </div>

                        })}*/}
                        </Switch>
                    </ScrollToTop>
                </div>
                <div className="Footer">
                    <Menu />
                </div>
            </div>
        </IntlProvider>
    }
}

export default withRouter(connect(state => ({ ...state.Language }), actions.Language)(App))



// WEBPACK FOOTER //
// ./src/component/App.js